"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.94 3.448a4.412 4.412 0 0 0-6.352 3.965v.555a3.7 3.7 0 0 0-3.183 3.664V17.3a3.7 3.7 0 0 0 3.7 3.7h7.79a3.7 3.7 0 0 0 3.7-3.7v-5.668c0-.424-.072-.832-.203-1.211a5 5 0 0 1-1.518.04c.204.343.32.743.32 1.171V17.3a2.3 2.3 0 0 1-2.3 2.3H8.105a2.3 2.3 0 0 1-2.3-2.3v-5.668a2.3 2.3 0 0 1 2.3-2.3h7.183a5 5 0 0 1-1.158-1.4H8.987v-.52a3.012 3.012 0 0 1 4.558-2.586c.065-.485.2-.948.394-1.378m-.601 10.076c0 .483-.256.906-.64 1.142v2.03a.7.7 0 1 1-1.4 0v-2.03a1.338 1.338 0 0 1 .7-2.48c.74 0 1.34.599 1.34 1.338",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.5 2.3a.7.7 0 0 1 .7.7v1.8H21a.7.7 0 0 1 0 1.4h-1.8V8a.7.7 0 1 1-1.4 0V6.2H16a.7.7 0 1 1 0-1.4h1.8V3a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=LockAddIcon24.js.map